<div fxLayoutAlign="end center" class="p-r-1">
	<span
		fxLayoutAlign="end center"
		[mtxPopoverTriggerFor]="filterPopover"
		class="quick-search-bar"
		floatLabel="never"
		mtxPopoverTriggerOn="click"
	>
		<mat-icon>filter_list</mat-icon>
		Filter
	</span>
</div>

<mtx-popover #filterPopover="mtxPopover" [closeOnPanelClick]="false">
	<mat-card class="p-0">
		<mat-card-content>
			<form [formGroup]="carrierFilterForm">
				<div class="p-1 label-text" fxLayout="column">
					<div
						class="p-r-1"
						fxFlex
						fxLayoutAlign="center center"
						formArrayName="formArray"
						*ngFor="let field of formArray.controls; let i = index"
					>
						<div [formGroupName]="i" fxFlex fxLayoutAlign="center center">
							<mat-form-field>
								<mat-label>Filter Field</mat-label>
								<mat-select formControlName="filterField">
									<mat-option *ngFor="let option of availableFields" [value]="option">{{
										option
									}}</mat-option>
								</mat-select>
							</mat-form-field>
							<div class="p-1" fxFlex fxLayoutAlign="center center">
								<span>Contains</span>
							</div>
							<mat-form-field>
								<input
									formControlName="filterText"
									matInput
									name="filter-text"
									placeholder="Filter Text"
									type="text"
								/>
							</mat-form-field>
							<mat-icon
								(click)="removeFormGroup(i)"
								class="cursor-pointer"
								*ngIf="formArray.length > 1"
								fxFlex
								fxLayoutAlign="center center"
							>
								delete_forever
							</mat-icon>
						</div>
					</div>
					<div fxLayout="row" fxLayoutGap="1rem">
						<div fxFlex fxLayoutAlign="end center">
							<span
								fxFlex
								fxLayoutAlign="start center"
								class="primary-text label-text-light font-size-16"
							>
								<span
									fxLayout="row"
									(click)="addFormGroup()"
									class="cursor-pointer"
									*ngIf="isAddConditionActive"
								>
									<mat-icon class="font-size-16">add</mat-icon>
									<span>Add condition</span>
								</span>
								<span fxLayout="row" class="label-text-light" *ngIf="!isAddConditionActive">
									<mat-icon class="font-size-16">add</mat-icon>
									<span>Add condition</span>
								</span>
							</span>
							<span
								fxFlex
								fxLayoutAlign="end center"
								(click)="clearFilters()"
								class="text-underline cursor-pointer m-r-1 font-size-16"
								>Clear filters</span
							>
							<button
								(click)="filterCarriers()"
								color="primary"
								[disabled]="!isFilterActive"
								mat-raised-button
							>
								<span>Filter</span>
							</button>
						</div>
					</div>
				</div>
			</form>
		</mat-card-content>
	</mat-card>
</mtx-popover>

<div class="p-1">
	<div class="p-b-1" *ngIf="dataSource.data.length > 0">
		<table [dataSource]="dataSource" class="mat-elevation-z1 full-width" mat-table>
			<ng-container matColumnDef="select">
				<th *matHeaderCellDef mat-header-cell>
					<mat-checkbox
						(change)="$event ? masterToggle() : null"
						[checked]="selection.hasValue() && isAllSelected()"
						[color]="'primary'"
						[disabled]="IS_NULL_OR_UNDEFINED(dataSource) || dataSource.data.length == 0"
						[indeterminate]="selection.hasValue() && !isAllSelected()"
					>
					</mat-checkbox>
				</th>
				<td *matCellDef="let row" mat-cell>
					<mat-checkbox
						(change)="$event ? selection.toggle(row) : null"
						(click)="$event.stopPropagation()"
						[checked]="selection.isSelected(row)"
						[color]="'primary'"
					>
					</mat-checkbox>
				</td>
			</ng-container>

			<ng-container matColumnDef="business_name">
				<th *matHeaderCellDef mat-header-cell>
					<span class="fs-13 color-black">Name</span>
				</th>
				<td *matCellDef="let element" mat-cell>
					{{ element.businessName }}
				</td>
			</ng-container>

			<ng-container matColumnDef="firm_mc">
				<th *matHeaderCellDef mat-header-cell>
					<span class="fs-13 color-black"> MC </span>
				</th>
				<td *matCellDef="let element" mat-cell>{{ element.firmMc }}</td>
			</ng-container>

			<ng-container matColumnDef="firm_dot">
				<th *matHeaderCellDef mat-header-cell>
					<span class="fs-13 color-black"> DOT </span>
				</th>
				<td *matCellDef="let element" mat-cell>{{ element.firmDot }}</td>
			</ng-container>

			<tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
			<tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
		</table>
		<mat-paginator
			(page)="getCarriersForPage($event)"
			[length]="filteredCarriers.length"
			[pageSize]="PAGE_SIZE"
			showFirstLastButtons
			*ngIf="filteredCarriers.length > PAGE_SIZE"
		>
		</mat-paginator>
	</div>
	<div *ngIf="dataSource.data.length < 1" class="p-b-2">
		<span class="font-size-20">No carrier found. Please modify your filter.</span>
	</div>

	<div fxLayout="row" fxLayoutGap="1rem">
		<div fxFlex fxLayoutAlign="end center">
			<span
				fxFlex
				fxLayoutAlign="end center"
				(click)="openLoadDetails()"
				class="text-underline cursor-pointer m-r-1"
				>Back</span
			>
			<button
				[mtxPopoverTriggerFor]="noCarrierPopover"
				mtxPopoverTriggerOn="click"
				(click)="excludeCarriers()"
				color="primary"
				mat-raised-button
			>
				<span>Exclude</span>
			</button>
		</div>
	</div>
</div>

<mtx-popover #noCarrierPopover="mtxPopover">
	<mat-card class="p-0 primary-border">
		<mat-card-content class="count-info-dropdown font-size-14">
			<div class="padding-0-5 primary-text">
				<p>Booking Assistant requires at least one carrier to run. Please update your filter.</p>
			</div>
		</mat-card-content>
	</mat-card>
</mtx-popover>
